<template>
  <div class="container" v-if="view">
      <div :class="items.status == 5?'van-notice-bar-fail':'van-notice-bar-info'" v-if="items.prompt">
        <van-icon name="info" />{{items.prompt}}
      </div>
    <div class="module" :style="items.prompt?'margin-top:0':''">
      <div class="item" style="position: relative;">
        <div class="left">
          <img src="../img/icon1.png" alt class="img" />
        </div>
        <div class="right">
          <span  class="absolute" :class="(items.status=='1'||items.status=='8'||items.status=='9')?'color1':(items.status=='2'||items.status == '3')?'color23':(items.status=='4')?'color4':(items.status=='5')?'color5':(items.status=='6')?'color6':'color7'">
          {{(items.status == '1'||items.status=='8'||items.status=='9')?'即将开始':(items.status == '2'||items.status == '3')?'进行中':(items.status == '4')?'积分发放中':(items.status == '5')?'失败':(items.status == '6')?'已完成':'已过期'}}
          </span>
          <h1>{{items.taskName}}</h1>
          <p style="padding-bottom:0.3rem;">活动时间&nbsp;&nbsp;
            <i>{{items.startTime}} ~ {{items.endTime}}</i>
          </p>
          <div style="display: inline-flex;width: 100%;">
            <h2 style="margin-right: auto;" v-if="items.rewardAmount">{{taskType == '3'||taskType == '4'?'最高':''}}奖励&nbsp;&nbsp;{{numStr(items.rewardAmount)}}积分</h2>
            <span class="link" @click="to('/call')" style='border:1px solid #dd2b1e'>活动咨询</span>&nbsp;&nbsp;
            <span class="link" @click="to('/orderList',{id:taskId})" style='border:1px solid #dd2b1e'>关联订单</span>
          </div>
        </div>
      </div>
      <step :status="items.status?items.status:''" :type="taskType?taskType:''"></step>
      <van-divider />
      <div class="item">
        <div class="left">
          <img src="../img/icon2.png" alt class="img" />
        </div>
        <div class="right">
          <h1>任务目标</h1>
          <div v-if="taskType == '1'">
            <p style="font-size:0.28rem;color:#535353;">在活动期间完成首单销售，额外奖励 <span style="color:#FF8E00;font-size:0.28rem;">{{items.rewardAmount}} 积分</span>。</p>
            <div v-if="items.status == '3'">
              <p>剩余时间</p>
              <p style="padding-top: 0.1rem;"><date :date="items.restMillisecond" @dateFn="getMsgFormSon" type="black"></date></p>
            </div>
          </div>
          <div v-if="taskType == '2'">
            <p style="font-size:0.28rem;color:#535353;">在活动期间完成销售增值服务，额外奖励 <span style="color:#FF8E00;font-size:0.28rem;">{{items.rewardAmount}} 积分</span></p>
            <div v-if="items.status == '3'">
              <p>剩余时间</p>
              <p style="padding-top: 0.1rem;"><date :date="items.restMillisecond" @dateFn="getMsgFormSon" type="black"></date></p>
            </div>
          </div>
          <div v-if="taskType == '3'"> 
            <p style="font-size:0.28rem;color:#535353;" v-for="(item,index) in items.stepReward" :key="index">
              销售<i style="color:#E02020;font-size: 0.28rem;">&nbsp;{{item.orderNum}}&nbsp;</i>单，额外奖励
              <span style="color:#FF8E00;font-size:0.28rem;" v-if="item.rewardAmount">&nbsp;{{numStr(item.rewardAmount)}}积分</span>
            </p>
          </div>
          <div v-if="taskType == '4'">
            <p style="font-size:0.28rem;color:#535353;" v-for="(item,index) in items.pkReward" :key="index">
              第<i style="color:#E02020;font-size: 0.28rem;">&nbsp;{{item.rank}}&nbsp;</i>名，额外奖励
              <span style="color:#FF8E00;font-size:0.28rem;" v-if="item.rewardAmount">&nbsp;{{numStr(item.rewardAmount)}}积分</span>
            </p>
            <p style="font-size:0.28rem;color:#535353;" v-if="items.shineRewardAmount != '0.00'">阳光普照，额外奖励<span style="color:#FF8E00;font-size:0.28rem;">&nbsp;{{numStr(items.shineRewardAmount)}}积分</span></p>
            <p style="font-size:0.28rem;color:#535353;" v-if="items.minOrderAmount != '0.00'">销售订单额达到{{items.minOrderAmount}}元，方可获得奖励。</p>
            <div v-if="items.status == '2'||items.status == '3'">
              <p>剩余时间</p>
              <p style="padding-top: 0.1rem;"><date :date="items.restMillisecond" @dateFn="getMsgFormSon" type="black"></date></p>
            </div>
          </div>
        </div>
      </div>
      <van-divider />
      <div class="item">
        <div class="left">
          <img src="../img/icon3.png" alt class="img" />
        </div>
        <div class="right">
          <h1>任务说明</h1>
          <p class="overflow" v-html="items.remark" style="font-size:initial;"></p>
        </div>
      </div>
    </div>
    <div class="module" v-if="taskType == '4'" style="padding: 0.4rem 0;">
      <div class="item" style="padding: 0 0.3rem;">
        <div class="left">
          <img src="../img/self.png" alt class="img" />
        </div>
        <div class="right" style="display: flex;margin-bottom:0.4rem;">
          <h1>业绩排名</h1>
          <div v-if="length != 0" style="width:80%;">
            <div style="display: flex;align-items: baseline;justify-content: space-between;" v-if="rank.myOrderAmount == 0">
              <span style="font-size:0.28rem;padding-left:0.2rem;float: left;color:#888888;">未达标, 暂无名次</span>
            </div>
            <div style="display: flex;align-items: baseline;justify-content: space-between;" v-else>
              <span style="font-size:0.28rem;padding-left:0.2rem;float: left;" v-if="rank.myRank != 0">第<i style="color:#c00;">&nbsp;{{rank.myRank}}&nbsp;</i>名</span>
              <span style="font-size:0.28rem;padding-left:0.2rem;float: left;color:#888888;" v-if="rank.myRank == 0">未达标, 暂无名次</span>
              <span style="font-size:0.3rem;float: right;">已销售&nbsp;&nbsp;<span style="font-size:0.32rem;font-weight: bold;">¥ {{rank.myOrderAmount}}</span></span>
            </div>
          </div>
        </div>
      </div>
      <div class="item" style="padding:0;">
        <rank :show="content" :id="taskId"  @funVaule="funValue" @dateFn="getRankFormSon"></rank>
      </div>
    </div>
    <div class="module" v-if="taskType == '3'">
      <div v-if="taskType == '3'">
        <div class="item">
          <div class="left">
            <img src="../img/icon4.png" alt class="img" />
          </div>
          <div class="right" style="position: relative;">
            <h1>完成进度</h1>
            <div style="position: absolute;right: 0;top: 0;display: flex;align-items: center;color:#616161;" v-if="items.status == '2'||items.status == '3'">
              剩余&nbsp;&nbsp;<date :date="items.restMillisecond" @dateFn="getMsgFormSon" type="black"></date>
              </div>
          </div>
        </div>
        <div style="padding: 0.3rem 0;" v-for="(item,index) in items.stepReward" :key="index+1">
          <van-progress color="linear-gradient(to right,#FF8E00, #F83A2D)" :show-pivot="false" stroke-width="10px" :percentage="item.percentage" />
          <p style="color:#999999;text-align: center;display: flex;justify-content: space-between;padding-top:0.2rem;">
          <span>销售增值服务{{item.orderNum}}单</span>
          <span>完成度<i style="color:#DD2B1E;">&nbsp;{{item.orderNumAlready}}</i>/{{item.orderNum}}单</span>
        </p>
        </div>
        <!-- <van-divider /> -->
      </div>
    </div>
    <div class="module goods" v-if="taskType == '3'||taskType == '4'">
      <div class="item" style="align-items: center;">
          <div class="left">
            <img src="../img/icon11.png" alt class="img" />
          </div>
          <div class="right" style="position: relative;">
            <h1>任务商品</h1>
          </div>
      </div>
      <div class="list" v-for="(item,index) in items.goodsList" :key="index+2">
        <div class="left">
          <img :src="item.goodsPicUrl" alt="" style="width: 1.6rem;height: 1.36rem;" v-if='item.goodsPicUrl'>
          <img src="../img/default.png" alt="" style="width: 1.6rem;height: 1.36rem;" v-else>
        </div>
        <div class="right" style="position: relative;">
          <h1 v-if="item.goodsName">{{fontNumber(item.goodsName)}}</h1>
          <div
            style="display: flex;width: 100%;align-items: center;position: absolute;bottom: -10%;align-items: center;"
          >
            <p style="margin-right: auto;color:#999999;">已完成&nbsp;{{item.goodsCount}}单</p>
            <span class="link" @click="jumpUrl(item)" style="border: 1px solid rgb(221, 43, 30);">分享商品</span>
          </div>
        </div>
      </div>
    </div>
    <div style="height:1rem;"></div>
    <div class="bottom" v-if="items.status == '9'||items.status == '2'">
      <a class="button" @click="get()">领取任务</a>
    </div>
  </div>
</template>

<script>
import step from "../../common/step/step";
import date from "../../common/date/date";
import rank from "../../activity/pkList/pkList";
export default {
  name: "info",
  components: {
    step,
    date,
    rank
  },
  data() {
    return {
      active: 1,
      items: [],
      taskId: "",
      view:false,
      canSubmit: true,
      taskType:"",
      content:"detail",
      rank:{
        myOrderAmount: "",
        myRank: ""
      },
      length:"",
      keepAlive:true,
      channelType:""
    };
  },
  computed: {},
  filters: {},
  created() {
    if (this.$route.query.id) {
      this.taskId = this.$route.query.id;
      this.taskType = this.$route.query.taskType;
      this.detail();
    }
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
  methods: {
    detail() {
      let post = {
        taskId: this.taskId,
        memberId: JSON.parse(sessionStorage.getItem("user")).memberId,
      };
      let apiServe;
      if(this.taskType == '1') apiServe = this.$api.taskFirstDetail // 首单任务
      if(this.taskType == '2') apiServe = this.$api.taskResaleDetail // 复销激活
      if(this.taskType == '3') apiServe = this.$api.taskDetail // 阶梯出单
      if(this.taskType == '4') apiServe = this.$api.taskPkDetail // pk业绩
      apiServe(post).then((res) => {
        this.items = res.data;
        this.canSubmit = true;
        this.view = true
      });
    },
    get(){
      if (!this.canSubmit) return;
      this.canSubmit = false;
      let post = {
        taskId: this.taskId,
        memberId: JSON.parse(sessionStorage.getItem("user")).memberId,
      };
      this.$api.taskReceive(post).then((res) => {
        if(res.errno == '0'){
          this.keepAlive = false
          this.$toast.success('任务领取成功');
          setTimeout(() => {
             this.detail()
          }, 2000);
          }
      });
    },
    funValue() { // 查看更多业绩排名
      this.$router.push('/pkList?id='+this.taskId)
    },
    jumpUrl(item) {
      window.location.href = item.goodsUrl;
    },
    to(path, query) {
      this.$router.push({
        path: path,
        query: query
      });
    },
    getMsgFormSon(times) {
      console.log("通知秒数剩余0",times)
      this.items.restMillisecond = "0"
      this.items.status = "7";
      console.log('页面状态',this.items.status)
    },
    getRankFormSon(items,length){
      console.log(items)
      console.log(length)
      this.rank = items
      this.length = length
    },
    fontNumber (date) {
      const length = date.length
      if (length > 30) {
        var str = ''
        str = date.substring(0, 34) + '...'
        return str
      } else {
        return date
      }
    },
    numStr(num){ // 数字整型
    let result = num.toString().indexOf(".");
      if (result != -1) {
        let str = num.toString().split(".")[1];
        if (str == "00") num = parseInt(num);
      }
      return num
  }
  },
  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave',to)
    if (to.path == "/taskList") {
      to.meta.keepAlive = this.keepAlive
    } else {
      to.meta.keepAlive = false
    }
    next();
  }
};
</script>

<style scoped lang="scss">
$color1: #ffffff;
$color2: #aaaaaa;
$color3: #888888;
$color4: #535353;
$color5: #ff8e00;
$color6: #dd2b1e;
$size24: 0.24rem;
$size28: 0.28rem;
$size32: 0.32rem;
$size36: 0.36rem;

.container {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  .module {
    margin-top: 0.2rem;
    padding: 0.4rem 0.3rem;
    background: $color1;
    .item {
      display: flex;
      .left {
        width: 0.5rem;
      }
      .right {
        flex: 1;
        h1 {
          font-size: 0.3rem;
          width: 72%;
        }
        p {
          color: $color3;
          font-size: $size24;
          padding: 0.3rem 0 0;
          i {
            color: $color4;
            font-style: normal;
          }
        }
        div {
          h2 {
            padding: 0.12rem 0.2rem;
            width: fit-content;
            color: $color5;
            background: rgba(255, 142, 0, 0.05);
          }
        }
      }
    }
  }
  .goods{
    .list {
      display: flex;
      padding:0.3rem 0 0.3rem;
      // margin-bottom: 0.4rem;
      border-bottom: 1px solid #EEEEEE;
      &:last-child{
        border-bottom: none;
      }
        .left {
        width: 1.6rem;
        height: 1.36rem;
        padding-right: 0.25rem;
      }
      .right {
        flex: 1;
        h1 {
          font-size: $size28;
        }
      }
    }
  }
  .van-notice-bar-info,.van-notice-bar-fail{
    padding: 0.16rem 0.3rem;
    display: flex;
    i{
      font-size: 0.32rem;
      padding-right: 0.12rem;
    }
  }
  .van-notice-bar-info{
    color: rgb(255, 102, 0);
    background: rgb(254, 247, 224);
  }
  .van-notice-bar-fail{
    color: #F75151;
    background: #FFEDED;
  }
  .bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: $color1;
    padding: 0.2rem 0.3rem;
    box-sizing: border-box;
    .button {
      display: flex;
      justify-content: center;
      width: 100%;
      padding: 0.26rem 0;
      text-align: center;
      font-size: $size36;
      color: #ffffff;
      background: linear-gradient(
        90deg,
        rgba(240, 86, 64, 1) 0%,
        rgba(221, 43, 30, 1) 100%
      );
      border-radius: 0.12rem;
    }
  }
}
.link {
  padding: 0.12rem 0.2rem;
  border-radius: 0.08rem;
  // border: 1px solid $color6;
  color: $color6;
  font-size: $size24;
}
.img {
  width: 0.36rem;
  padding-top: 0.05rem;
}
i{
  font-style:normal;
}
.absolute {
  position: absolute;
  right: 0;
  top: 5%;
  font-size: 0.2rem;
  text-align: center;
  color: #fff;
  border-radius: 0.08rem;
  padding: 0.1rem 0.26rem;
}
.overflow{
  overflow:hidden;
  white-space:normal;
  word-break:break-all;
  text-overflow:ellipsis;
}
.font28{
  font-size: 0.28rem;
  color:#535353;
}
.color1{
    background: rgba(255, 142, 0, 0.6);
  }
  .color23{
    background: rgba(0, 176, 149, 1);
  }
  .color4{
    background: rgba(255, 142, 0,1);
  }
  .color5{
    background: rgba(247, 81, 81, 1);
  }
  .color6{
    background: rgba(0, 176, 149, 0.6);
  }
  .color7{
    background: rgba(204, 204, 204, 1);
  }
</style>
<style lang="scss">

</style>